<script setup lang="ts">
import { AppText } from '@shared/ui/typography'
import { AppIcon } from '@shared/ui/icons'

import { useFilterOpsStatus } from '../../model/filter-ops-status.hook'
import TutorBillingTriStateSwitcher from '../TutorBillingTriStateSwitcher.vue'

defineOptions({
  name: 'FilterOpsStatus',
})

const {
  isOpen,
  labelId,
  valueId,
  containerRef,
  triggerRef,
  floatingRef,
  floatingStyles,
  flags,
  labels,
  stateOptions,
  getValue,
  setValue,
  summary,
  chevronIcon,
  setToggle,
} = useFilterOpsStatus()
</script>

<template>
  <div
    ref="containerRef"
    class="filter-ops-status"
  >
    <AppText
      :id="labelId"
      name="body2"
      color="slate-900"
    >
      Legal status
    </AppText>

    <button
      ref="triggerRef"
      type="button"
      :class="['filter-ops-status__trigger', { 'filter-ops-status__trigger--open': isOpen }]"
      aria-haspopup="dialog"
      :aria-expanded="isOpen"
      :aria-labelledby="`${labelId} ${valueId}`"
      @click="setToggle"
    >
      <AppText
        :id="valueId"
        name="body1"
        color="slate-900"
        class="filter-ops-status__value"
      >
        {{ summary }}
      </AppText>
      <AppIcon
        :icon="chevronIcon"
        color="slate-500"
      />
    </button>

    <div
      v-if="isOpen"
      ref="floatingRef"
      class="filter-ops-status__panel"
      role="dialog"
      :aria-labelledby="labelId"
      :style="floatingStyles"
    >
      <div
        v-for="flag in flags"
        :key="flag"
        class="filter-ops-status__row"
      >
        <AppText
          name="body2"
          color="slate-900"
        >
          {{ labels[flag] }}
        </AppText>
        <TutorBillingTriStateSwitcher
          :value="getValue(flag)"
          :options="stateOptions"
          :label="labels[flag]"
          @change="setValue(flag, $event)"
        />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss" src="./FilterOpsStatus.scss" />
